import { Button, Modal, Tag } from "antd";
import Clock from "react-live-clock";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout } from "../redux/slice/userSlice";
import { ExclamationCircleFilled } from "@ant-design/icons";

function LayoutHeader() {
  const User = useSelector((state: any) => state?.User?.user);
  const { confirm } = Modal;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const greetBasedOnTime = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) {
      return "Good Morning";
    } else if (currentHour < 16) {
      return "Good Afternoon";
    } else {
      return "Good Evening";
    }
  };
  const showLogoutConfirm = () => {
    confirm({
      title: "Are you sure you want to logout?",
      icon: <ExclamationCircleFilled />,
      content: "You will need to login again to access the system.",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk() {
        dispatch(logout());
        navigate("/");
      },
    });
  };
  return (
    <div className="dashboard-Header">
      <div>{greetBasedOnTime()}!</div>
      <div style={{ flex: 1 }} />
      <Tag color="blue" style={{ textTransform: "uppercase" }}>
        {" "}
        {User?.user?.type}
      </Tag>
      <Button style={{ width: "120px" }} size="small">
        <Clock format={"h:mm:ss A"} ticking={true} />
      </Button>
      <Button size="small" className="text-danger" onClick={showLogoutConfirm}>
        LOGOUT
      </Button>
    </div>
  );
}

export default LayoutHeader;
